var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMenuBurger = function SvgIconMenuBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#374957",
    clipPath: "url(#icon_menu_burger_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 11H1a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2ZM23 4H1a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2ZM23 18H1a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_menu_burger_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconMenuBurger;